import { ClipboardCheck } from 'lucide-react';
import {
  Card, CardContent 
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function CountsView() {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12">
        <ClipboardCheck className="mb-4 h-12 w-12 text-muted-foreground" />
        <p className="text-lg font-medium">Cycle Counts</p>
        <p className="text-sm text-muted-foreground">Schedule and manage inventory counts</p>
        <Button className="mt-4">Start Count</Button>
      </CardContent>
    </Card>
  );
}
